import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useSetLanguage } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import { getMerchantHeaderDescriptionText } from '@/helpers'

import useCancellationsPortal from '../useCancellationsPortal/useCancellationsPortal'
import useHandle404 from '../useHandle404/useHandle404'
import useReturnPortalInfo from '../useReturnPortalInfo/useReturnPortalInfo'

const usePortalPage = ({ slug, isGiftReturn = false, requiresOrderRecovery = false }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { setContext } = useContext(AppContext)
  const { returnPortalInfo, loadingReturnPortalInfo, errorReturnPortalInfo, changeLanguage } = useReturnPortalInfo(
    slug,
    setContext
  )
  const { portalType } = useCancellationsPortal()

  const isOrderRecoveryDisabled =
    requiresOrderRecovery && Boolean(returnPortalInfo) && !returnPortalInfo.preferences?.allows_order_recovery

  useSetLanguage(returnPortalInfo?.store?.supported_languages, returnPortalInfo?.store?.default_language)
  useHandle404(errorReturnPortalInfo || isOrderRecoveryDisabled, navigate)

  const descriptionText = t(
    getMerchantHeaderDescriptionText(returnPortalInfo?.preferences?.transaction_types, portalType, isGiftReturn)
  )

  return { returnPortalInfo, loadingReturnPortalInfo, changeLanguage, descriptionText, portalType }
}

export default usePortalPage
